import { Resources } from "@tsTypes/subject-schema";
import {
  buildFullPath,
  getBannerLinksForContext,
  getNextLinkedResourceForSubject,
  getResourceDisplayName,
  getUserPreferredSubTopicTitle,
} from "@utils/routing";
import {
  useSubTopicMeta,
  useTopicMeta,
} from "../../../../../components/CoreDataProvider";
import ResourceBanner from "./ResourceBanner";

export default function LinkedTopicResourceBanner({
  subject,
  topicDocumentId,
  subTopicDocumentId,
  currentResource,
  linkedResource,
  subTopicTitle,
}: {
  subject: string;
  topicDocumentId: string;
  subTopicDocumentId?: string;
  currentResource: Resources;
  linkedResource?: Resources | null;
  subTopicTitle?: string;
}) {
  const topicMeta = useTopicMeta(topicDocumentId);
  const subTopicMeta = useSubTopicMeta(subTopicDocumentId ?? "");
  const resolvedSubTopicTitle = subTopicTitle ?? subTopicMeta?.title;
  const bestNextResource =
    linkedResource ?? getNextLinkedResourceForSubject(subject, currentResource);

  const bestNextLink =
    bestNextResource === null
      ? null
      : {
          label: getResourceDisplayName(bestNextResource),
          href: buildFullPath({
            subject: subject,
            resource: bestNextResource,
            topicNumber: topicMeta.index.toString(),
            topicTitle: topicMeta.title,
            subTopicTitle: resolvedSubTopicTitle,
          }),
          resource: bestNextResource,
        };

  const links = resolvedSubTopicTitle
    ? getBannerLinksForContext({
        context: "subtopic",
        subjectNameLower: subject,
        currentResource,
        topicNumber: topicMeta.index.toString(),
        topicTitle: topicMeta.title,
        subTopicTitle: resolvedSubTopicTitle,
      })
    : getBannerLinksForContext({
        context: "topic",
        subjectNameLower: subject,
        currentResource,
        topicNumber: topicMeta.index.toString(),
        topicTitle: topicMeta.title,
      });
  const linksHeading = resolvedSubTopicTitle
    ? subTopicMeta
      ? `Other Sub-topic ${getUserPreferredSubTopicTitle(subTopicMeta).split(":")[0]} resources`
      : "Other Sub-topic resources"
    : `Other topic ${topicMeta.number} resources`;

  let currentResourceMessage = `topic ${topicMeta.number} ${currentResource}`;
  if (subTopicMeta) {
    const subTopicNumber =
      getUserPreferredSubTopicTitle(subTopicMeta).split(":")[0];
    currentResourceMessage = `sub-topic ${subTopicNumber} ${currentResource}, covering "${subTopicMeta.title}"`;
  }

  return (
    <ResourceBanner
      subject={subject}
      currentResourceMessage={currentResourceMessage}
      suggestedLink={bestNextLink}
      linksHeading={linksHeading}
      links={links}
    />
  );
}
